import { Height } from "@mui/icons-material";
import styled from "styled-components";

export const CMTitleColumn = styled.div((props) => ({
    "& h5": {
      margin: "2px 0",
      fontWeight: 400,
  
      "&:first-of-type": {
        fontWeight: 600,
      },
    },
  }));

export const CMTracks = styled.div(props => ({
    margin: ' 0',
    padding: '24px 0',
    
    'h3': {
        marginTop: 0,
        fontWeight: 500,
        fontFamily: props.theme.fontFamilies.workSans,
        [`@media (min-width: 2000px)`]: {
          fontSize:"3vh"
        },
    },

    '& .MuiDataGrid-root': {
        '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 400,
            [`@media (min-width: 2000px)`]: {
              fontSize:"2.5vh",
              height:"150px",
              lineHeight:"150px"
            },
        },
        '& .MuiDataGrid-columnHeaderTitleContainer': {
          [`@media (min-width: 2000px)`]: {
            maxHeight:"100%",
            height:"100px"
          },
        },
        '& .MuiDataGrid-columnHeaders': {
          [`@media (min-width: 2000px)`]: {
            maxHeight:"100% !important",
            height:"150px",
          },
        },
        '& .MuiDataGrid-columnHeader': {
          [`@media (min-width: 2000px)`]: {
            height:"150px !important",
          },
        },
        '& .MuiDataGrid-cell': {
            paddingTop: props.theme.spacers["2"],
            paddingBottom: props.theme.spacers["2"],
            boxSizing: 'none',
            borderBottom: `solid 1px #e5e5e5`,
            backgroundPosition: 'bottom',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'unset',
            backgroundImage: 'unset',
        },
    }
}));